export default "__VITE_ASSET__CYjnwpSN__"